<template>
  <div>
    <v-card>
      <v-card-title>
        registration dates
        <v-spacer></v-spacer>
        <v-layout row wrap justify-end>
          <v-flex xs5 px-1>
            <v-text-field
              v-model="search_filter"
              append-icon="search"
              :label="$t('extracurriculares.register.search')"
              clearable
            ></v-text-field>
          </v-flex>
          <v-flex xs3 px-1>
            <v-select
              v-model="status_filter"
              :items="status_items"
              :label="$t('extracurriculares.courses.form.status')"
              clearable
            ></v-select>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="dates_to_show"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">{{ props.item.id }}</td>
          <td class="text-xs-center">{{ props.item.start_date }}</td>
          <td class="text-xs-center">{{ props.item.end_date }}</td>
          <td class="text-xs-center">{{ props.item.course_start_date }}</td>
          <td class="text-xs-center">
            <span v-if="isClosed(`${props.item.end_date} 23:59:59`)" class='error white--text pa-2'>Cerrado</span>
            <span v-else class='success white--text pa-2'>Abierto</span>
          </td>
          <td class="text-xs-center">
            <v-btn
              @click="registerDetail(props.item.id)"
              color="primary">
              Ver detalle de registro
            </v-btn>
          </td>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog
      v-model="students_detail_dialog"
      scrollable fullscreen
      transition="dialog-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="students_detail_dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ course.name }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
          </v-toolbar-items>
        </v-toolbar>
        <register-detail-students
          :students_registered="register_detail"
          v-on:updateDetail="fetchRegisterDetail"
          :course="course"
          :registration_id="registration_id"
        >
        </register-detail-students>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import registerDetailStudents from './enrollment_registration_students'
  export default {
    name: 'enrollment-registration-dates-view',
    props: {
      course: {
        type: Object,
        required: true
      },
    },
    components: {
      'register-detail-students': registerDetailStudents,
    },
    data() {
      return {
        search: '',
        headers: [
          { text: 'Id', value: 'id', align: 'center' },
          { text: 'Fecha inicial registro', value: 'start_date', align: 'center' },
          { text: 'Fecha final registro', value: 'end_date', align: 'center' },
          { text: 'Fecha inicio curso', value: 'course_start_date', align: 'center' },
          { text: 'Estado', value: 'status', align: 'center' },
          { text: 'Acciones', value: 'actions', align: 'center' },
        ],
        dates_to_show: this.$props.course.registration_dates,
        status_items: [
          { value: 1, text: 'Activo' },
          { value: 0, text: 'Inactivo' },
        ],
        search_filter: '',
        status_filter: '',
        register_detail: [],
        students_detail_dialog: false,
        registration_id: null,
      }
    },
    watch: {
      course() {
        this.filter_courses()
      },
      search_filter() {
        this.filter_courses()
      },
      status_filter() {
        this.filter_courses()
      },
    },
    methods: {
      filter_courses() {
        let dates_to_show = this.$props.course.registration_dates

        if (this.search_filter && this.search_filter.trim() !== '') {
          dates_to_show = dates_to_show
            .filter(course => course.name.toUpperCase().indexOf(this.search_filter.toUpperCase()) > -1)
        }

        if (this.status_filter && this.status_filter !== '') {
          dates_to_show = dates_to_show.filter(course => course.status === this.status_filter)
        }

        this.dates_to_show = dates_to_show
      },
      isClosed(date) {
        const currentDate = new Date()
        const register_date = Date.parse(date)
        if (register_date < currentDate) {
          return true
        }

        return false

      },
      registerDetail(registration_id) {
        this.registration_id = registration_id
        axios.get(`/api/extracurriculares/enrollment/register/detail/${registration_id}/${this.course.id}`)
          .then(resp => {
            if (resp.status === 200) {
              this.students_detail_dialog = true
              this.register_detail = resp.data.detail
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
      fetchRegisterDetail() {
        this.registerDetail(this.registration_id)
        this.$emit('updateCoursesList')
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/admin/enrollment_registration_dates.vue